import { Component, inject, input, OnInit, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { UiModule } from 'src/app/components/ui.module';
import { DiscussionsService } from '../../../service/discussions.service';
import { DiscussionComment } from '../../../types';
import { DiscussionThreadCommentAdderComponent } from '../discussion-thread-comment-adder/discussion-thread-comment-adder.component';
import { DiscussionThreadCommentComponent } from '../discussion-thread-comment/discussion-thread-comment.component';

@Component({
  selector: 'app-discussion-thread',
  imports: [DiscussionThreadCommentComponent, UiModule, DiscussionThreadCommentAdderComponent],
  templateUrl: './discussion-thread.component.html',
  styleUrl: './discussion-thread.component.scss',
})
export class DiscussionThreadComponent implements OnInit {
  private discussionService = inject(DiscussionsService);

  public type = input.required<string>();
  public id = input.required<string>();
  public canAddComments = input<boolean>(true);

  public isLoading = signal<boolean>(false);
  public comments = signal<DiscussionComment[]>([]);

  ngOnInit() {
    this.loadComments();
  }

  private loadComments() {
    this.isLoading.set(true);
    this.discussionService
      .getComments(this.type(), this.id(), 99999, 1)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe((data) => this.comments.set(data.items));
  }

  createNewComment(comment: string) {
    this.discussionService.createComment(this.type(), this.id(), comment).subscribe((newComment) => {
      this.comments.update((current) => [...current, newComment]);
    });
  }
}
